module.exports = __webpack_public_path__ + "static/media/realtime.fe53943c.svg";